module.exports = __webpack_public_path__ + "img/blog-5.5f3a544c.png";